const acuponRouter = {
  path: '',
  component: () => import('@/layout'),
  children: [
    {
      path: '/acuponList',
      name: 'acuponList',
      meta: { title: '优惠卷列表' },
      component: () => import(/* webpackChunkName: "activities" */ '@/pages/acupon')
    }
  ]
}

export default acuponRouter
